import { render } from "./App.vue?vue&type=template&id=fc79df2a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=fc79df2a&lang=css"

import exportComponent from "D:\\智诚大数据\\禁种铲毒\\禁种铲毒平台\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__